import { c as _c } from "react/compiler-runtime";
import { useActiveAdministrative } from './useAdministrativeLevels';
export const useActiveProvince = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      level: "province",
      paramKey: "filter[province]",
      parents: [{
        paramKey: "filter[country]",
        argName: "country",
        required: false
      }]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const r = useActiveAdministrative(t0);
  let t1;
  if ($[1] !== r.active || $[2] !== r.activeLabel || $[3] !== r.isLoading || $[4] !== r.items || $[5] !== r.selectedParam || $[6] !== r.setActive) {
    t1 = {
      provinceParam: r.selectedParam,
      provinces: r.items,
      activeProvince: r.active,
      activeProvinceLabel: r.activeLabel,
      isLoading: r.isLoading,
      setActiveProvince: r.setActive
    };
    $[1] = r.active;
    $[2] = r.activeLabel;
    $[3] = r.isLoading;
    $[4] = r.items;
    $[5] = r.selectedParam;
    $[6] = r.setActive;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1 as const;
};